import React from 'react';
import styled from 'styled-components';

import { useAdminGetDashboardNewUsersDataQuery } from '../../hooks/reactQuery/dashboard/useAdminGetDashboardNewUsersDataQuery';
import { CardError } from './CardError';
import { SummaryCard } from './SummaryCard';

type Props = {
  fromDate: string | null;
  toDate: string | null;
  selectedLabel: string;
  marketID: string | null;
};

export const ModelApplicationsV2: React.FC<Props> = ({
  fromDate,
  toDate,
  selectedLabel,
  marketID,
}) => {
  const { data, isFetching, isError, refetch } = useAdminGetDashboardNewUsersDataQuery({
    fromDate: fromDate || '',
    toDate: toDate || '',
    marketID,
  });

  if (isError && !isFetching) {
    return (
      <SummaryCardGrid>
        <CardError onRetry={() => refetch()} />
        <CardError onRetry={() => refetch()} />
      </SummaryCardGrid>
    );
  }

  return (
    <SummaryCardGrid>
      <SummaryCard
        cardHeading={`Applications:`}
        isFetching={isFetching}
        totalModels={data?.totalUserApplications || 0}
        totalFreelancers={data?.totalFreelancerUserApplications || 0}
        selectedLabel={selectedLabel}
      />
      <SummaryCard
        cardHeading={`New users added:`}
        isFetching={isFetching}
        totalModels={data?.totalNewUsers || 0}
        totalFreelancers={data?.totalNewFreelancerUsers || 0}
        selectedLabel={selectedLabel}
      />
    </SummaryCardGrid>
  );
};

const SummaryCardGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 24px;
`;
